//Get_Crime.ts ==============================================================
import "../Util/Prototypes";

import * as CrimeSearch from "./CrimeSearch";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as FilterByType from "./FilterByType_Crime";
import * as GeoFence_Crime from "./GeoFence_Crime";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as Settings_Crime from "./Settings_Crime";
import * as SnackBar from "../Util/SnackBar";
import * as Spinner from "../Util/Spinner";
import * as TimePeriod from "./TimePeriod_Crime";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Widgets from "../Widgets/Widgets";

//ESRI javascript API.
import FeatureFilter from "@arcgis/core/layers/support/FeatureFilter";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

export function search() {
   Util.logMsg("Top of Get_Crime.search");

   if (Spinner.busy || !MainMap.view2D) {
      return; //Quit if busy.
   }
   Spinner.show();

   reactiveUtils.when(() => MainMap.mapView?.updating === false, function () {
      if (DrawerMenu.curToolName.startsWith("Crime")) {
         Spinner.hide();
      }
   });

   //Get settings.
   const ss = Settings_Crime.ss;
   const fl = CrimeSearch.featureLayer;

   CrimeSearch.layer.totRec = 0;
   CrimeSearch.layer.fs = null;

   CrimeSearch.layer.spec = Util_App.getLayerSpec(ss.crimePoints_layerName);
   if (!CrimeSearch.layer.spec) {
      Util.errMsg("Crime points layer not found: " + ss.crimePoints_layerName);
      return;
   }

   //Create query task.
   const query = fl.createQuery();
   query.outSpatialReference = MainMap.activeView.spatialReference;
   query.geometryPrecision = 0;

   if (GeoFence_Crime.geoFenceGeom) {
      query.geometry = GeoFence_Crime.geoFenceGeom;
   }

   query.where = buildWhereString();
   Util.logMsg("Crime search Where for " + CrimeSearch.layer.spec.layerName + ":\n" + query.where);

   fl.definitionExpression = query.where;

   fl.queryFeatures(query).then(queryTask_success).catch(queryTask_failed);

   CrimeSearch.featureLayerView.filter = new FeatureFilter({ where: query.where, geometry: query.geometry });

   MainMap.activeView.closePopup(); // Close popup for former cluster that no longer displays.
}

//Crime points search completed event.
function queryTask_success(raw_fs: __esri.FeatureSet) {
   import("@arcgis/core/PopupTemplate").then(({ default: PopupTemplate }) => {
      const fs = raw_fs;
      const layer = CrimeSearch.layer;
      layer.name = CrimeSearch.layer.spec.layerName;
      layer.fs = fs;
      layer.begRec = 0;
      layer.totRec = fs.features.length;
      layer.endRec = Math.min(layer.totRec, Settings.maxRecordCount) - 1;
      layer.numRec = Math.min(layer.totRec, Settings.maxSearchRecPerPage);
      layer.zoomAllMBR = Util_App.getMBRFeatureSet(fs);

      CrimeSearch.featureLayer.legendEnabled = true;

      //No records found.
      if (layer.totRec === 0) {
         Spinner.hide();
         SnackBar.show("No crimes found", 2);
         CrimeSearch.featureLayer.legendEnabled = false;
         CrimeSearch.clearResults(false);

         if (DrawerMenu.curToolName === "Crime Results") {
            DrawerMenu.closeTool();
         }

         if (DrawerMenu.prevToolName === "Crime Search") {
            DrawerMenu.prevToolClick(DrawerMenu.prevToolName);
         }
         return;
      }

      displayResults();

   }).catch((error: Error) => {
      Util.errMsg('An error occurred while loading the popup template module:', error);
   });
}

//Display results.
export function displayResults() {

   //Build left panel results.
   if (DrawerMenu.curToolName === "Crime Results") {
      Widgets.show("Crime Results");

   } else { //Crime search was the current tool.
      DrawerMenu.showTool("Crime Results");
   }
}

//Query task failed.
function queryTask_failed(error: Error): void {
   Spinner.hide();
   Util.errMsg("Query Task failed", error);
}

function buildWhereString() {
   const ss = Settings_Crime.ss;
   let sql: string = "";

   for (const crimeType of FilterByType.selectedCrimeTypes) {
      const crimeNum = ss.crimeTypeDict[crimeType];
      sql += buildWhereLine(sql, ss.categoryField, "Number", crimeNum);
   }

   if (sql === "") {
      sql = "1=1"; //No crime types selected, so select all.
   } else {
      sql = sql.replace(/ AND /g, " OR ");
      sql = "(" + sql + ")";
   }

   //Crime date.
   sql += buildWhereLine(sql, ss.crimeDateField, "Date", TimePeriod.fromDateYMD, "Min");
   sql += buildWhereLine(sql, ss.crimeDateField, "Date", TimePeriod.toDateYMD, "Max");

   return sql;
}

//Set where string for a single field.
function buildWhereLine(inWhere: string, fieldName: string, dataType: string, fieldValue: any, minMax?: string) {
   let sql: string = "";

   if (fieldName !== "" && fieldValue !== "") {
      if (inWhere !== "") {
         sql += " AND ";
      }

      if (dataType === "Number") {
         if (minMax === "Min") {
            sql += fieldName + " >= " + fieldValue;
         } else if (minMax === "Max") {
            sql += fieldName + " <= " + fieldValue;
         } else {
            sql += fieldName + " = " + fieldValue;
         }

      } else if (dataType === "Date") {
         if (minMax === "Min") {
            sql += fieldName + " >= timestamp '" + fieldValue + "'";
         } else if (minMax === "Max") {
            sql += fieldName + " <= timestamp '" + fieldValue + "'";
         } else {
            sql += fieldName + " = timestamp '" + fieldValue + "'";
         }

      } else if (dataType === "Txt") {
         sql += fieldName + " = '" + fieldValue + "'";

      } else if (dataType === "Contains") {
         sql += fieldName + " Like '%" + fieldValue + "%'";
      }
   }
   return sql;
}
